// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__34pwG","error":"Textarea_error__1kBnk","readonly":"Textarea_readonly__1apMQ","disabled":"Textarea_disabled__2xyz9"};